import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { MpOrdersMarkingApi } from '@/Api/MpOrdersMarking/MpOrdersMarkingApi';
import { AddressType, OrderMarker } from '@/Enums';
import { purchasesPageAsyncActions } from '@/Pages/Purchases/services';
import { LogisticsApi } from '@/Api/Logistics/LogisticsApi';
import { Toasts } from '@/Components/Toast/Toast';
import { useLocalization } from '@/Hooks';

export const useAddressActions = (onClose: () => void, addressType: AddressType, orderId?: number) => {
  const dispatch = useDispatch();

  const {
    notifications: { CopyAddressSuccess },
  } = useLocalization();

  const getFormattedAddress = useCallback(async () => {
    if (!orderId) return;

    const response = await LogisticsApi.getFormattedAddress(orderId, addressType);

    return navigator.clipboard.writeText(response).then(() => {
      Toasts.showSuccess({
        text: CopyAddressSuccess.text,
      });
    });
  }, [CopyAddressSuccess, addressType, orderId]);

  const changeAddressDisabledState = useCallback(
    async (addressEditDisabled?: boolean) => {
      if (!orderId) return;

      const marker = addressEditDisabled ? OrderMarker.AddressEditEnabled : OrderMarker.AddressEditDisabled;

      await MpOrdersMarkingApi.changeAddressEditDisabled({
        orderIds: [orderId],
        orderMarker: marker,
      });

      dispatch(purchasesPageAsyncActions.getPurchasesWithCurrentFilters());
      onClose();
    },
    [orderId],
  );

  return {
    getFormattedAddress,
    changeAddressDisabledState,
  };
};
